import React from 'react'
import { Paper, Button } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import Text from '../Text'
import { avisoDaSuspensao, linkDeRecargaSeguro } from '../../libs/suspensaoOficial'

const COR = '#ef4444'

/**
 * Faixa da suspensão do WhatsApp oficial (carteira sem saldo, ou suspensa pelo
 * operador). Diz o que está acontecendo, desde quando e o que resolve — por
 * falta de saldo, com o botão que leva à recarga.
 *
 * Silenciosa por contrato, como a faixa de saúde da conta Meta: sem suspensão
 * não renderiza NADA.
 */
function SuspensaoOficialBanner({ suspensao, linkRecarga, className = '' }) {
  const aviso = avisoDaSuspensao(suspensao, Date.now())
  if (!aviso) return null
  const link = aviso.ofereceRecarga ? linkDeRecargaSeguro(linkRecarga) : null

  return (
    <div className={className} role="alert">
      <Paper elevation={0} sx={{ backgroundColor: `${COR}14`, borderLeft: `4px solid ${COR}` }}>
        <div className="p-4 flex items-start gap-3">
          <ErrorOutlineIcon style={{ color: COR, fontSize: 22, marginTop: 2 }} />
          <div className="flex-1 min-w-0">
            <Text className="text-sm font-black" style={{ color: COR }}>
              {aviso.titulo}
            </Text>
            <Text className="text-xs font-light opacity-90 mt-1 leading-relaxed">{aviso.mensagem}</Text>
            <Text className="text-xs font-light opacity-70 mt-1 leading-relaxed">{aviso.rodape}</Text>

            {link && (
              <Button
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                size="small"
                variant="contained"
                disableElevation
                endIcon={<OpenInNewIcon style={{ fontSize: 14 }} />}
                sx={{ mt: 1.5, backgroundColor: COR, textTransform: 'none', '&:hover': { backgroundColor: '#dc2626' } }}
              >
                Recarregar e reativar
              </Button>
            )}
          </div>
        </div>
      </Paper>
    </div>
  )
}

export default SuspensaoOficialBanner
